import React, { useState, useEffect } from 'react';
import { Save, Share2, ExternalLink } from 'lucide-react';
import { api } from '../../api/client';
import { showToast } from '../../components/common/Toast';

export default function AdminSocialPage() {
  const [contact, setContact] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/cms/contact')
      .then((res) => {
        if (res?.success) setContact(res.contact || {});
      })
      .catch((err) => showToast(err.message, 'error'))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (platform, val) => {
    setContact((prev) => ({ ...prev, [platform]: val }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await api.put('/cms/contact', contact);
      if (res?.success) {
        showToast('Ijtimoiy tarmoqlar havolalari saqlandi!', 'success');
      }
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSave} className="space-y-6 max-w-3xl">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-serif text-lg font-bold text-slate-900">
            Ijtimoiy Tarmoqlar Havolalari
          </h2>
          <p className="text-xs text-slate-500">
            Sayt foterida va aloqa bo‘limida ko‘rsatiladigan rasmiy sahifalar
          </p>
        </div>

        <button
          type="submit"
          disabled={saving}
          className="inline-flex items-center px-5 py-2 text-xs font-semibold text-[#091322] bg-[#c5a880] hover:bg-[#d4b993] rounded shadow-sm transition-colors"
        >
          <Save className="w-4 h-4 mr-1.5" />
          {saving ? 'Saqlanmoqda...' : 'Saqlash'}
        </button>
      </div>

      <div className="bg-white rounded-lg border border-slate-200 shadow-2xs p-6 space-y-4 text-xs">
        <div>
          <label className="block font-semibold text-slate-700 uppercase mb-1">Telegram Kanal / Bot / Guruh</label>
          <input
            type="url"
            placeholder="https://t.me/advokatfirm"
            value={contact.telegram || ''}
            onChange={(e) => handleChange('telegram', e.target.value)}
            className="w-full px-3 py-2 border rounded focus:border-[#c5a880]"
          />
        </div>

        <div>
          <label className="block font-semibold text-slate-700 uppercase mb-1">LinkedIn Sahifa</label>
          <input
            type="url"
            placeholder="https://linkedin.com/company/advokatfirm"
            value={contact.linkedin || ''}
            onChange={(e) => handleChange('linkedin', e.target.value)}
            className="w-full px-3 py-2 border rounded focus:border-[#c5a880]"
          />
        </div>


        <div>
          <label className="block font-semibold text-slate-700 uppercase mb-1">WhatsApp Havola</label>
          <input
            type="url"
            placeholder="https://wa.me/998712000000"
            value={contact.whatsapp || ''}
            onChange={(e) => handleChange('whatsapp', e.target.value)}
            className="w-full px-3 py-2 border rounded focus:border-[#c5a880]"
          />
        </div>
      </div>
    </form>
  );
}
